import { useTranslation } from '@aimsos/i18n';

/** Time-of-day greeting key. Kept pure so it's trivial to test. */
export function greetingKey(hour) {
  if (hour < 12) return 'workspaceSelector.morning';
  if (hour < 18) return 'workspaceSelector.afternoon';
  return 'workspaceSelector.evening';
}

/**
 * Selector header: the WORKSPACE SELECTION eyebrow, a time-of-day greeting with
 * the user's first name, and the access count.
 *
 * `count` must be the server's total across all pages, not the number of rows
 * fetched so far — see `useWorkspaces().totalCount`.
 */
function SelectorHeader({ name, count }) {
  const { t } = useTranslation('core-shell');
  const greeting = t(greetingKey(new Date().getHours()));

  return (
    <div className="mb-6">
      <p className="mb-2 flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-content-faint">
        <span className="h-px w-6 bg-edge-strong" />
        {/* Light/dark pair: a single emerald shade washes out on one of the two
            surfaces. Same reasoning applies to every accent on this screen. */}
        <span className="h-1.5 w-1.5 rounded-full bg-emerald-600 dark:bg-emerald-400" />
        {t('workspaceSelector.eyebrow')}
      </p>
      <h1 className="text-2xl font-bold tracking-tight text-content sm:text-3xl">
        {greeting}
        {name && (
          <>
            ,{' '}
            <span className="bg-gradient-to-r from-brand-600 to-sky-600 bg-clip-text text-transparent dark:from-brand-400 dark:to-sky-400">
              {name}
            </span>
          </>
        )}
      </h1>
      {/* Hidden while the list is still loading (count === 0) — a placeholder
          count is worse than no count. */}
      {count > 0 && (
        <p className="mt-1.5 text-sm text-content-muted">{t('workspaceSelector.accessCount', { count })}</p>
      )}
    </div>
  );
}

export default SelectorHeader;
